import Page, { PageProps } from '@/components/page';
import RouterTabs from '@/components/router-tabs';
import OrgPolicyIntentsForm from '@/pages/wais/org-policy/intents-form';
import OrgPolicySensitiveDataForm from '@/pages/wais/org-policy/sensitive-data-form';
import { FC, useMemo } from 'react';
import ServiceAccessForm from './service-access-form';
import PortalForm from './portal-form';
import OrgMcpAccessForm from './mcp-access-form';
import useFeature from '@/hooks/use-feature.hook';
import { Navigate } from '@tanstack/react-router';

const OrgPolicyPage: FC<PageProps> = () => {
  const { hasPolicyV2 } = useFeature();

  const panels = useMemo(() => {
    const panels = [
      {
        label: 'Services',
        path: 'services',
        component: <ServiceAccessForm />,
      },
      {
        label: 'MCP Tools',
        path: 'mcp-tools',
        component: <OrgMcpAccessForm />,
      },
      {
        label: 'Sensitive Data',
        path: 'sensitive-data',
        component: <OrgPolicySensitiveDataForm />,
      },
      {
        label: 'Classifiers',
        path: 'classifiers',
        component: <OrgPolicyIntentsForm />,
      },
      {
        label: 'Portal Chat',
        path: 'portal',
        component: <PortalForm />,
      },
    ];

    return panels;
  }, []);

  if (hasPolicyV2) {
    return <Navigate to="/config/policy/scoped" />;
  }

  return (
    <Page title="Default Policy">
      <RouterTabs panels={panels} />
    </Page>
  );
};

export default OrgPolicyPage;
